import React from "react";
import "./SignUp.css";

const SignUp = () => {
  return (
    <div>
      <h1>This is SignUp page</h1>
    </div>
  );
};

export default SignUp;
